import { render, staticRenderFns } from "./GraphDetail34Template.vue?vue&type=template&id=baf06d4c&scoped=true"
import script from "./GraphDetail34Template.vue?vue&type=script&lang=js"
export * from "./GraphDetail34Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf06d4c",
  null
  
)

export default component.exports